import script from "./GenerateBillPdf.vue?vue&type=script&setup=true&lang=ts"
export * from "./GenerateBillPdf.vue?vue&type=script&setup=true&lang=ts"

import "./GenerateBillPdf.vue?vue&type=style&index=0&id=1ddc43a9&lang=less"

const __exports__ = script;

export default __exports__